module.exports = __webpack_public_path__ + "img/demand-title.1383b87c.png";